import {
    SAVE_USERS_DEVICE_INFO_FAILED,
    SAVE_USERS_DEVICE_INFO_SUCCUSS,
    SAVE_USERS_DEVICE_INFO_START,
  } from '../store/types';
  
  const initialState = {
    device: null,
    error: {
      message: null,
      flagged: false,
    },
  };
  
  // eslint-disable-next-line no-undef
  export const devicereducer = (state = initialState, {type, payload}) => {
    switch (type) {
      case SAVE_USERS_DEVICE_INFO_START:
        return {...state};
  
      case SAVE_USERS_DEVICE_INFO_SUCCUSS:
        return {...state, device: payload};
  
      case SAVE_USERS_DEVICE_INFO_FAILED:
        return {
          ...state,
          error: {
            flagged: true,
            message: payload,
          },
        };
  
      default:
        return state;
    }
  };
  